import { Directive, Input, ElementRef, OnInit, HostListener } from '@angular/core';

@Directive({
    selector: 'input[dipsePatternFilter]',
    standalone: false
})
export class PatternFilterDirective implements OnInit {
  @Input() dipsePatternFilter: string;
  @Input() pattern: string;
  private regex: RegExp;
  private element: HTMLInputElement;

  constructor(
    private elementRef: ElementRef
  ) {
    this.element = this.elementRef.nativeElement;
    this.element.spellcheck = false;
  }

  @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent) {
    const value = (event.clipboardData || window['clipboardData']).getData('text');
    if (!this.regex.test(value)) {
      event.preventDefault();
    }
  }

  @HostListener('keydown', ['$event']) onKeyDown(event: KeyboardEvent) {
    switch (event.key) {
      case 'ArrowLeft':
      case 'Left': // IE11
      case 'ArrowRight':
      case 'Right': // IE11
      case 'Backspace':
      case 'Delete':
      case 'Control':
      case 'Shift':
      case 'Tab':
        break;

      default:
        if (!event.ctrlKey) {
          const value = this.element.value || '';
          const selectionStart = this.element.selectionStart;
          const key = event.key === 'Spacebar' ? ' ' : event.key; // IE11
          if (!this.regex.test(value.substring(0, selectionStart) + key + value.substring(selectionStart))) {
            event.preventDefault();
          }
        }
    }
  }

  ngOnInit() {
    this.regex = new RegExp(this.pattern || this.dipsePatternFilter);
  }
}
